import { lazy } from 'react'

export const PeriodAffectAppetite = lazy(() => import('./PeriodAffectAppetite'))
